import { Observable, of } from 'rxjs';
import { first, map, mergeMap, take } from 'rxjs/operators';

import { InstitutionDataStore, institutionSelectors, ThesaurusDataStore, ThesaurusTermDataStore, thesaurusTermSelectors } from '@skinsoft/entity';
import { ConditionReportDataStore, conditionReportSelectors } from '@skinsoft/entity/src/condition-report';
import { getTranslatedString } from '@skinsoft/ui';
import { SearchFeatured } from '@skinsoft/ui';


export async function resolveAuthorFunction(searchFeatured: SearchFeatured, locale: string): Promise<string> {
    const thesaurusDataStore: ThesaurusTermDataStore = ThesaurusTermDataStore.getInstance();

    if (!searchFeatured.credits || !searchFeatured.credits.authorFunction) {
        return "";
    }

    return thesaurusDataStore.fetchOne(searchFeatured.credits.authorFunction as string).pipe(
        take(1),
        map(thesaurusTerm => {
            const resolvedCredits = getTranslatedString(thesaurusTermSelectors.preferredTerm(thesaurusTerm), locale);
            return resolvedCredits;
        })).toPromise();
}

export async function resolveInstitution(searchFeatured: SearchFeatured, locale: string): Promise<string> {
    const institutionDataStore: InstitutionDataStore = InstitutionDataStore.getInstance();
    if (!searchFeatured.institution) {
        return "";
    }
    return institutionDataStore.fetchOne(searchFeatured.institution as string).pipe(
        take(1),
        map(institution => {
            const resolvedInstitution = institutionSelectors.title(institution, locale);
            return resolvedInstitution;
        })).toPromise()
}


export async function resolveDenomination(searchFeatured: SearchFeatured, locale: string): Promise<string> {
    const thesaurusDataStore: ThesaurusTermDataStore = ThesaurusTermDataStore.getInstance();
    if (!searchFeatured.denomination) {
        return "";
    }

    return thesaurusDataStore.fetchOne(searchFeatured.denomination as string).pipe(
        take(1),
        map(thesaurusTerm => {
            const resolvedDenomination = getTranslatedString(thesaurusTermSelectors.preferredTerm(thesaurusTerm), locale)
            return resolvedDenomination;
        }))
        .toPromise()
}

export async function resolveDomain(searchFeatured: SearchFeatured, locale: string): Promise<string> {
    const thesaurusDataStore: ThesaurusTermDataStore = ThesaurusTermDataStore.getInstance();
    if (!searchFeatured.domain) {
        return "";
    }
    return thesaurusDataStore.fetchOne(searchFeatured.domain as string).pipe(
        take(1),
        map(thesaurusTerm => {
            const resolvedDomain = getTranslatedString(thesaurusTermSelectors.preferredTerm(thesaurusTerm), locale);
            return resolvedDomain;
        })).toPromise()
}


export async function resolveLastReportDate(searchFeatured: SearchFeatured): Promise<string> {
    const conditionReportDataStore = ConditionReportDataStore.getInstance()
    if (!searchFeatured.lastConditionReportId) {
        return "";
    }
    return conditionReportDataStore.fetchOne(searchFeatured.lastConditionReportId).pipe(
        first(),
        map(
            conditionReport => {
                const date = conditionReportSelectors.date(conditionReport)
                return date;
            }
        )).toPromise();
}